export default [
  {
    name: 'title',
    element: 'title',
    value: 'Aanvraag',
    dontSend: true,
  },
  {
    name: 'leadType',
    element: 'select',
    value: 'Offerte',
    options: ['Offerte', 'Proefrit', 'Lease', 'Bel mij'],
    required: true,
    hideWhenInLocationState: true,
  },
  {
    name: 'name',
    type: 'text',
    element: 'input',
    placeholder: 'Voor- en achternaam*',
    required: true,
  },
  {
    name: 'telephone',
    type: 'text',
    element: 'input',
    placeholder: 'Telefoonnummer*',
    required: true,
  },
  {
    name: 'email',
    type: 'email',
    element: 'input',
    placeholder: 'E-mailadres*',
    required: true,
  },
  {
    name: 'Gewenste datum',
    element: 'input',
    placeholder: 'Gewenste datum*',
    required: true,
    dependsOn: [{
      field: 'leadType',
      value: 'Proefrit',
    }],
  },
  // NOTE: this is copied in Wijnne for Private Lease
  {
    name: 'inruil-title',
    dontSend: true,
    element: 'title',
    value: 'Heeft u een inruilauto?',
    dependsOn: [{
      field: 'leadType',
      value: 'Offerte',
    }],
  },
  {
    name: 'inruil',
    dontSend: true,
    element: 'radio',
    type: 'radio',
    // placeholder: 'Heeft u een inruilauto?',
    options: ['ja', 'nee'],
    dependsOn: [{
      field: 'leadType',
      value: 'Offerte',
    }],
  },
  {
    name: 'licensePlate',
    propertyOf: 'vehicleTradein',
    element: 'input',
    placeholder: 'Kenteken',
    dependsOn: [{
      field: 'leadType',
      value: 'Offerte',
    }, {
      field: 'inruil',
      value: 'ja',
    }],
  },
  {
    name: 'odometer',
    propertyOf: 'vehicleTradein',
    element: 'input',
    placeholder: 'Tellerstand',
    dependsOn: [{
      field: 'leadType',
      value: 'Offerte',
    }, {
      field: 'inruil',
      value: 'ja',
    }],
  },
  {
    name: 'comments',
    propertyOf: 'vehicleTradein',
    element: 'textarea',
    placeholder: 'Opmerkingen',
    dependsOn: [{
      field: 'leadType',
      value: 'Offerte',
    }, {
      field: 'inruil',
      value: 'ja',
    }],
  },
  {
    name: 'images',
    propertyOf: 'vehicleTradein',
    element: 'file',
    multi: true,
    value: [undefined],
    placeholder: 'Foto',
    dependsOn: [{
      field: 'leadType',
      value: 'Offerte',
    }, {
      field: 'inruil',
      value: 'ja',
    }],
  },
];
